// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6VLiu","requiredAsterisk":"Info_requiredAsterisk__15zmd"};